<template>
  <div class="signUpModal">
    <template v-if="isEditing">
      <div class="c-modal">
        <div class="c-modal__content">
          <sc-text
            tag="h2"
            v-if="fields && fields.signUpTitle"
            :field="fields.signUpTitle"
            class="c-modal__title"
          />
          <sc-rich-text
            v-if="fields && fields.signUpContent"
            :field="fields.signUpContent"
            class="c-modal__text"
          />
          <sc-link
            v-if="fields && fields.signUpCta"
            :field="fields.signUpCta"
            class="c-cta--primary"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <VueFinalModal
        v-model="smallModal"
        class="final-modal smallModal"
        :class="{ scroll: isScrollable }"
        content-class="final-modal-content"
        content-transition="vfm-fade"
        overlay-transition="vfm-fade"
      >
        <div ref="modalContent" class="c-modal">
          <div class="c-modal__content">
            <button class="c-modal__close" @click="smallModal = false">X</button>
            <sc-text
              tag="h2"
              v-if="fields && fields.signUpTitle"
              :field="fields.signUpTitle"
              class="c-modal__title"
            />
            <sc-rich-text
              v-if="fields && fields.signUpContent"
              :field="fields.signUpContent"
              class="c-modal__text"
            />
            <sc-link
              v-if="fields && fields.signUpCta"
              :field="fields.signUpCta"
              class="c-cta--primary"
              @click="smallModal = false"
            />
          </div>
        </div>
      </VueFinalModal>
    </template>
  </div>
</template>

<script>
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue';
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { useWindowSize, useElementSize } from '@vueuse/core';
import { VueFinalModal } from 'vue-final-modal';
import 'vue-final-modal/style.css';

export default {
  name: 'CIS-Sign-Up-Modal',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScLink: Link,
    VueFinalModal
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    // Window Height
    const { height } = useWindowSize();
    // Large Modal
    const smallModal = ref(false);
    // Has Opened
    const hasOpened = ref(false);
    // Modal Content
    const modalContent = ref(null);
    // Get Modal Content Size
    const modalSize = reactive(useElementSize(modalContent));

    var percent = props?.fields?.signUpScrollDepth?.value || 75;
    var percentage = percent / 100;

    const handleScroll = () => {
      const scrollY = window?.scrollY;
      const docHeight = document?.documentElement?.scrollHeight;
      const winHeight = window?.innerHeight;

      const scrollPercent = scrollY / (docHeight - winHeight);

      if (
        props?.fields?.signUpTitle?.value?.length > 0 &&
        props?.fields?.signUpCta?.value?.href?.length > 0
      ) {
        if (!hasOpened.value && scrollPercent >= percentage) {
          smallModal.value = true;
          hasOpened.value = true;
        }
      }
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return {
      height,
      smallModal,
      modalContent,
      modalSize,
      hasOpened
    };
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    },
    isScrollable() {
      return this.modalSize?.height > this.height;
    }
  }
};
</script>
<style lang="scss" scoped>
.signUpModal {
  text-align: center;
}

.c-modal {
  &__close {
    font-size: 2.5rem;
    padding: 1.5rem 2rem;
  }

  &__content {
    padding: 5rem 3rem 3rem 3rem !important;
    align-items: center;
  }

  &__title {
    font-size: 2.8rem !important;
    line-height: 3.5rem !important;
    margin: 0 auto !important;
    margin-bottom: 2rem !important;
  }

  &__text {
    width: 100%;

    &:deep() {
      img {
        max-width: 100% !important;
      }
    }
  }

  .c-cta--primary {
    font-weight: 500;
    margin-bottom: 0 !important;

    &:after {
      top: 0.1rem;
    }
  }
}
</style>
